/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";
import type { LizardUnitsEnum } from "./LizardUnitsEnum";
import {
  LizardUnitsEnumFromJSON,
  LizardUnitsEnumFromJSONTyped,
  LizardUnitsEnumToJSON,
  LizardUnitsEnumToJSONTyped,
} from "./LizardUnitsEnum";

/**
 * Mixin for validating "offset" and "duration"
 * Assumes simulation to be present on Serializer
 * @export
 * @interface PatchedLizardTimeseriesRain
 */
export interface PatchedLizardTimeseriesRain {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number;
  /**
   * event duration in seconds. -9999 is the 'infinite duration' value (only allowed in conjunction with infinite simulations
   */
  duration?: number | null;
  /**
   *
   */
  multiplier?: number;
  /**
   *
   */
  referenceUuid?: string;
  /**
   *
   */
  startDatetime?: Date;
  /**
   *
   */
  interpolate?: boolean;
  /**
   * Timeseries provided as a nested list. The inner list consists of exactly 2 values: timestamp, value
   */
  readonly values?: Array<Array<number>>;
  /**
   *
   */
  units?: LizardUnitsEnum;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
}

/**
 * Check if a given object implements the PatchedLizardTimeseriesRain interface.
 */
export function instanceOfPatchedLizardTimeseriesRain(
  value: object
): value is PatchedLizardTimeseriesRain {
  return true;
}

export function PatchedLizardTimeseriesRainFromJSON(json: any): PatchedLizardTimeseriesRain {
  return PatchedLizardTimeseriesRainFromJSONTyped(json, false);
}

export function PatchedLizardTimeseriesRainFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedLizardTimeseriesRain {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"] == null ? undefined : json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    multiplier: json["multiplier"] == null ? undefined : json["multiplier"],
    referenceUuid: json["reference_uuid"] == null ? undefined : json["reference_uuid"],
    startDatetime:
      json["start_datetime"] == null ? undefined : parseDateTime(json["start_datetime"]),
    interpolate: json["interpolate"] == null ? undefined : json["interpolate"],
    values: json["values"] == null ? undefined : json["values"],
    units: json["units"] == null ? undefined : LizardUnitsEnumFromJSON(json["units"]),
    id: json["id"] == null ? undefined : json["id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
  };
}

export function PatchedLizardTimeseriesRainToJSON(json: any): PatchedLizardTimeseriesRain {
  return PatchedLizardTimeseriesRainToJSONTyped(json, false);
}

export function PatchedLizardTimeseriesRainToJSONTyped(
  value?: Omit<PatchedLizardTimeseriesRain, "url" | "simulation" | "values" | "id" | "uid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    multiplier: value["multiplier"],
    reference_uuid: value["referenceUuid"],
    start_datetime:
      value["startDatetime"] == null
        ? value["startDatetime"]
        : serializeDateTime(value["startDatetime"]),
    interpolate: value["interpolate"],
    units: LizardUnitsEnumToJSON(value["units"]),
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
  };
}
